import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Fade, Grid, Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import theme from "../../theme/theme";
import { Link as RouterLink } from "react-router-dom";

const ConsultancyBullets = ({ bullets, loading }) => {

    return (
        <>
            {loading ?
                <Grid container
                    sx={{
                        margin: '50px auto',
                        padding: '0 2rem',
                        maxWidth: `calc(${theme.width.maxwidth} + 4rem)`,
                    }}
                >
                    <Grid item md={4} xs={12}
                        sx={{
                            paddingRight: '30px',
                        }}
                    >
                        {Array.from(new Array(4)).map(() => (
                            <Skeleton
                                variant="text"
                                width="100%"
                                sx={{
                                    fontSize: '1.7rem',
                                }}
                            />
                        ))}
                        <Skeleton
                            variant="rounded"
                            width="130px"
                            height="44px"
                            sx={{
                                marginTop: '30px',
                                borderRadius: '50px',
                            }}
                        />
                    </Grid>
                    <Grid item md={8} xs={12}>
                        {Array.from(new Array(9)).map(() => (
                            <>
                                <Box
                                    sx={{
                                        marginBottom: '20px',
                                        display: 'flex',
                                        width: '100%',
                                    }}
                                >
                                    <Skeleton
                                        variant="circular"
                                        width="16px"
                                        height="16px"
                                        sx={{
                                            marginRight: '10px',
                                            marginTop: '7px',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            width: '100%',
                                        }}
                                    >
                                        <Skeleton
                                            variant="text"
                                            width="100%"
                                            sx={{
                                                fontSize: '1.3rem',
                                            }}
                                        />
                                        <Skeleton
                                            variant="text"
                                            width="100%"
                                            sx={{
                                                fontSize: '1.3rem',
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </>
                        ))}
                    </Grid>
                </Grid>
            : bullets ?
            <Box
                sx={{
                    margin: '50px auto',
                    padding: '0 4rem',
                    maxWidth: `calc(${theme.width.maxwidth} + 8rem)`,
                }}
                id="bullets"
            >
                <Grid container>
                    <Grid item md={4} xs={12}
                        sx={{
                            paddingRight: '30px',
                        }}
                    >
                        <Fade in={true} timeout={1000}>
                            <Box
                                sx={{
                                    position: 'sticky',
                                    top: '30%'
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '1.3rem',
                                        fontWeight: '600',
                                        color: '#265DA5',
                                    }}
                                >
                                    {bullets.introduction_text}
                                </Typography>
                                {bullets?.introduction_button?.button_label && bullets?.introduction_button?.button_link ?
                                    <Button
                                        sx={{
                                            color: '#ffffff',
                                            backgroundColor: '#265DA5',
                                            fontSize: '1rem',
                                            borderRadius: '50px',
                                            fontWeight: '600',
                                            padding: '0.5rem 1rem',
                                            marginTop: '30px',
                                            marginBottom: '25px',
                                            '&:hover': {
                                                backgroundColor: "#E9531C",
                                            },
                                        }}
                                        component={RouterLink}
                                        to={bullets?.introduction_button?.button_link}
                                    >
                                        {bullets?.introduction_button?.button_label}
                                    </Button>
                                    : null}
                            </Box>
                        </Fade>
                    </Grid>
                    <Grid item md={8} xs={12}>
                        {bullets.bullet_points.map((bulletPoint, index) => (
                            <Fade in={true} timeout={2000}>
                                <Box
                                    sx={{
                                        marginBottom: '20px',
                                        display: 'flex',
                                    }}
                                >
                                    {/* <FontAwesomeIcon
                                        icon={faCheckCircle}
                                        style={{
                                            color: bullets.bullet_color,
                                            marginRight: '10px',
                                            marginTop: '4px',
                                        }}
                                    /> */}
                                    <Typography
                                        key={index}
                                    >
                                        {bulletPoint.bullet_text}
                                    </Typography>
                                </Box>
                            </Fade>
                        ))}
                    </Grid>
                </Grid>
            </Box>
            : null}
        </>
    );
}

export default ConsultancyBullets;